export class Yetki {

  id: number;
  isim: string;
  checked = false;


  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }
}
